export const CONNECTED_LABEL = user => `Welcome ${user}`;
